"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
// tslint:disable:max-classes-per-file
var $dyn;
(function ($dyn) {
    var controls;
    (function (controls) {
        /**
         * Framework class for Integer controls
         */
        var Integer = /** @class */ (function (_super) {
            __extends(Integer, _super);
            function Integer() {
                return _super !== null && _super.apply(this, arguments) || this;
            }
            Integer.prototype.init = function (data, element) {
                _super.prototype.init.call(this, data, element);
                this.UserFormat[","] = "";
            };
            return Integer;
        }(controls.Number));
        controls.Integer = Integer;
        Integer.prototype.MaxValueNumber = "2147483647";
        Integer.prototype.MinValueNumber = "-2147483648";
        /**
         * Framework class for Int64 controls
         */
        var Int64 = /** @class */ (function (_super) {
            __extends(Int64, _super);
            function Int64(data, element, parent, role) {
                var _this = _super.call(this, data, element, parent, role) || this;
                _this.UserFriendlyTypeName = $dyn.label("Input_TypeName_Int64");
                return _this;
            }
            return Int64;
        }(Integer));
        controls.Int64 = Int64;
        Int64.prototype.MaxValueNumber = "9223372036854775807";
        Int64.prototype.MinValueNumber = "-9223372036854775808";
        $dyn.adapter({ id: "Integer", controlType: "Integer", template: "Number" });
        $dyn.adapter({ id: "Int64", controlType: "Int64", template: "Number" });
        $dyn.adapter({ id: "IntegerSummary", controlType: "Number", template: "SummaryField" });
        $dyn.adapter({ id: "Int64Summary", controlType: "Number", template: "SummaryField" });
        $dyn.adapter({ id: "IntegerLabel", controlType: "Number", template: "Label" });
        $dyn.adapter({ id: "Int64Label", controlType: "Number", template: "Label" });
        $dyn.adapter({ id: "IntegerCardCell", controlType: "Number", template: "CardCell" });
        $dyn.adapter({ id: "Int64CardCell", controlType: "Number", template: "CardCell" });
        var IntegerCell = /** @class */ (function (_super) {
            __extends(IntegerCell, _super);
            function IntegerCell(data, element, parent, role) {
                var _this = _super.call(this, data, element, parent, role) || this;
                // All cells are editable (because allow edit is not virtualized)
                _this.AllowEdit = $dyn.observable(true);
                return _this;
            }
            IntegerCell.prototype.updateValue = function () {
                return this._onChange();
            };
            IntegerCell.prototype.addMessage = function (messageId) {
                if (!this.messages) {
                    this.messages = [];
                }
                this.messages.push(messageId);
            };
            IntegerCell.prototype._onChange = function () {
                var isDirty = false;
                if (this._committedValue !== this.currentValue) {
                    isDirty = true;
                    this._committedValue = this.currentValue;
                    // Raise a retargeted "change" event
                    this.RaiseEvent($dyn.ui.ChangeEvent, {
                        bubbles: true,
                    });
                }
                return isDirty;
            };
            IntegerCell.prototype._setValue = function () {
                // Force the value to be dirty
                this._committedValue = undefined;
            };
            IntegerCell.prototype.GetState = function () {
                // todo: Check against value?
                return {
                    formattedValue: this.currentValue,
                    messages: this.messages
                };
            };
            IntegerCell.prototype.ApplyState = function (clientState) {
                var retVal = $.Deferred();
                var formattedValue = clientState && clientState.formattedValue;
                if (formattedValue !== undefined) {
                    this.currentValue = formattedValue;
                }
                retVal.resolve();
                return retVal;
            };
            IntegerCell.prototype.attached = function () {
                this._ = {};
                _super.prototype.attached.call(this);
                this._committedValue = this.currentValue;
                this.Value = $dyn.observable(this._committedValue);
            };
            Object.defineProperty(IntegerCell.prototype, "currentValue", {
                get: function () {
                    return this._.input.value;
                },
                set: function (value) {
                    this._.input.value = value;
                },
                enumerable: false,
                configurable: true
            });
            return IntegerCell;
        }(Integer));
        controls.IntegerCell = IntegerCell;
        $dyn.ui.addPropertiesToPrototype(IntegerCell.prototype, {
            validating: { defaultValue: false, attribute: "data-dyn-validating" }
        });
        var Int64Cell = /** @class */ (function (_super) {
            __extends(Int64Cell, _super);
            function Int64Cell(data, element, parent, role) {
                var _this = _super.call(this, data, element, parent, role) || this;
                // All cells are editable (because allow edit is not virtualized)
                _this.AllowEdit = $dyn.observable(true);
                return _this;
            }
            Int64Cell.prototype.updateValue = function () {
                return this._onChange();
            };
            Int64Cell.prototype.addMessage = function (messageId) {
                if (!this.messages) {
                    this.messages = [];
                }
                this.messages.push(messageId);
            };
            Int64Cell.prototype._onChange = function () {
                var isDirty = false;
                if (this._committedValue !== this.currentValue) {
                    isDirty = true;
                    this._committedValue = this.currentValue;
                    // Raise a retargeted "change" event
                    this.RaiseEvent($dyn.ui.ChangeEvent, {
                        bubbles: true,
                    });
                }
                return isDirty;
            };
            Int64Cell.prototype._setValue = function () {
                // Force the value to be dirty
                this._committedValue = undefined;
            };
            Int64Cell.prototype.GetState = function () {
                // todo: Check against value?
                return {
                    formattedValue: this.currentValue,
                    messages: this.messages
                };
            };
            Int64Cell.prototype.ApplyState = function (clientState) {
                var retVal = $.Deferred();
                var formattedValue = clientState && clientState.formattedValue;
                if (formattedValue !== undefined) {
                    this.currentValue = formattedValue;
                }
                retVal.resolve();
                return retVal;
            };
            Int64Cell.prototype.attached = function () {
                this._ = {};
                _super.prototype.attached.call(this);
                this._committedValue = this.currentValue;
                this.Value = $dyn.observable(this._committedValue);
            };
            Object.defineProperty(Int64Cell.prototype, "currentValue", {
                get: function () {
                    return this._.input.value;
                },
                set: function (value) {
                    this._.input.value = value;
                },
                enumerable: false,
                configurable: true
            });
            return Int64Cell;
        }(Int64));
        controls.Int64Cell = Int64Cell;
        $dyn.ui.addPropertiesToPrototype(Int64Cell.prototype, {
            validating: { defaultValue: false, attribute: "data-dyn-validating" }
        });
        $dyn.cellAdapter({ id: "Integer", template: "NumberCell" });
        $dyn.cellAdapter({ id: "Int64", template: "NumberCell" });
        $dyn.cellAdapter({ id: "Integer", controlType: "IntegerCell", template: "NumberCellEditor", type: $dyn.cellTypes.editor });
        $dyn.cellAdapter({ id: "Int64", controlType: "Int64Cell", template: "NumberCellEditor", type: $dyn.cellTypes.editor });
    })(controls = $dyn.controls || ($dyn.controls = {}));
})($dyn || ($dyn = {}));

//# sourceMappingURL=Integer.js.map
